import React, { useMemo, useEffect, useState, useRef } from 'react'
import { useDispatch } from 'react-redux'


import { addMessage } from '../slices/ui'
import { useSettings } from '../slices/settings'
import { 
  setUserPosition, 
  useMonitorUserPosition, 
  useUserIsOnTrail,
  useUserIsNearTrail} from '../slices/userposition'
import { useGeolocation } from '../slices/geolocation'
import { useUrlParams, useSpatialSearch } from '../hooks'
import { useTrailProfile } from '../api'
import { OUT_OF_TRAIL } from '../trans'

const UserPositionManager = () => {
  const dispatch = useDispatch()
  const { route_id, trail_id = 1 } = useUrlParams()
  const { showAlert } = useSettings()
  const monitorIsActive = useMonitorUserPosition()
  const isOnTrail = useUserIsOnTrail()
  const isNearTrail = useUserIsNearTrail()
  const { lnglat } = useGeolocation()
  const profile = useTrailProfile({routeId: route_id, trailId: trail_id}, {skip: !trail_id})
  const pointOnProfile = useSpatialSearch(profile, lnglat, 3000)
  const dispatchOutOfTrailAlert = showAlert && monitorIsActive && isNearTrail && !isOnTrail 

  useEffect(()=>{
    dispatch(setUserPosition(pointOnProfile))
  }, [pointOnProfile, dispatch])


  useEffect(()=>{
    if (!dispatchOutOfTrailAlert) return
    dispatch(addMessage({
      message: OUT_OF_TRAIL,
      status: 'error',
      timeout: 4
    }))
  }, [dispatchOutOfTrailAlert, dispatch])


  //useEffect(()=>{
    //if (!isOnTrail || !isActive) return
    //requestAnimationFrame(()=>{
        //const ele = Array.from(document.querySelectorAll('.pwa__list__item.passed') || document.querySelectorAll('.pwa__list__item')).pop(-1)
        //if (ele){
          //const offset = 150;
          //const elementRect = ele.getBoundingClientRect();
          
          //if ( elementRect.top >= offset && (elementRect.bottom - offset) <= (window.innerHeight || document.documentElement.clientHeight)) return
          //const bodyRect = document.body.getBoundingClientRect();
          //const elementPosition = elementRect.top - bodyRect.top;
          //const offsetPosition = elementPosition - offset;

          //window.scrollTo({
            //top: offsetPosition,
            //behavior: 'smooth'
          //});
        //}
      //})
  //}, [isOnTrail, isActive, trail_id])
  //
  return null
}

export default UserPositionManager
